export enum AisProduct {
  AMDT = "AIP_AMDT",
  SUP = "AIP_SUP",
  AIC = "AIC",
  NOTAM = "NOTAM",
}
